// extracted by mini-css-extract-plugin
export default {"cardsContainer":"MainBody_cardsContainer__RTgTz","sectionHeading":"MainBody_sectionHeading__Q3NOh"};